import { Box, Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import { styled } from "@mui/system";
import NoDataImg from "../Assets/nodata.svg"; // Assuming you have the SVG file correctly imported
import CustomPagination from "../Components/Pagnination/Pagnination";

const NoDataOverlay = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
    }}
  >
    <img src={NoDataImg} alt="No Data" style={{ width: "200px" }} />
  </Box>
);

const LeftAlignedCell = styled("div")(({ theme }) => ({
  textAlign: "left",
}));

const TableContainer = ({
  rows,
  columns,
  pageSize,
  loading,
  page,
  handlePageChange,
  totalData,
  sx,
  style = {},
  pagination,
}) => {
  const centeredColumns = columns?.map((column) => ({
    ...column,
    headerAlign: column?.headerClassName ? undefined : "center",
    cellClassName: column?.cellClassName || "centered-cell",
  }));
  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "10px 10px",
        height: "100%",
        ...style,
      }}
    >
      <Grid container justifyContent="center" sx={{ height: "100%" }}>
        <Grid
          item
          xs={12}
          sx={{
            height: pagination === false ? "100%" : "calc(100% - 52px)",
            ...sx,
          }}
        >
          <DataGrid
            rows={rows}
            columns={centeredColumns}
            pageSize={pageSize}
            pagination
            paginationMode="server"
            getRowId={(e) => e.rowid}
            onPageChange={(newPage) => handlePageChange(newPage)}
            rowsPerPageOptions={[10]}
            rowCount={totalData}
            loading={loading}
            disableColumnResize
            disableColumnSorting={true}
            disableColumnMenu
            hideFooter
            slots={{ noRowsOverlay: NoDataOverlay }}
            slotProps={{
              loadingOverlay: {
                variant: "skeleton",
                noRowsVariant: "skeleton",
              },
            }}
            disableRowSelectionOnClick
            sx={{
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "300",
              },
              "& .MuiDataGrid-root": {
                borderRadius: "10px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "#b9cc0360",
                borderRadius: "0",
                border: "0.5px solid #000000",
                color: "#000",
                borderBottom:"none !important",
                fontSize:"18px",

                "&:first-of-type": {
                  borderLeft: "0px",
                },
                "&:last-of-type": {
                  borderRight: "0px",
                },
                textAlign: "center",
              },
              "& .MuiDataGrid-cell": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "0px",
                border: "0.5px solid #000",
                color: "#000",

                fontWeight: "200",
              },
              "& .MuiDataGrid-row": {
                cursor: "pointer",
              },
              "& .leftAlign": {
                textAlign: "left !important",
                justifyContent: "flex-start",
              },
              "& .leftAlignHeader": {
                textAlign: "left !important",
              },
              ".MuiDataGrid-cell:focus": { outline: "none" },
              ".MuiDataGrid-columnHeader:focus": { outline: "none" },
            }}
            components={{
              Cell: (params) => {
                if (params?.field === "email") {
                  return <LeftAlignedCell>{params?.value}</LeftAlignedCell>;
                }
                return params?.value;
              },
            }}
          />
        </Grid>
        {pagination === false
          ? false
          : true && (
              <Grid item xs={12}>
                <CustomPagination
                  page={page}
                  pageSize={pageSize}
                  handlePageChange={handlePageChange}
                  totalData={totalData}
                />
              </Grid>
            )}
      </Grid>
    </Box>
  );
};

export default TableContainer;
